import React from "react";

const Map = () => {
  return (
    <div>
      <iframe
        title="Google Maps"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1994.4591557716676!2d-77.27988812816695!3d1.2170056998430845!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e2ed486e6068151%3A0x77fdcaded059dc13!2sASEGURAR%20LTDA.!5e0!3m2!1ses-419!2sco!4v1568649854011!5m2!1ses-419!2sco"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Map;
